import React from 'react';
import { BrowserRouter as Router} from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Modal from 'react-modal';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes/AppRoutes';
import WorkspaceProvider from './context/WorkspaceContext';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.errorInfo) return <>Something went wrong</>;
    return this.props.children;
  }
}


Modal.setAppElement('#root'); // Set the app element for react-modal

function App() {
  if (/^\/api\/?$/.test(window.location.pathname)) {
    return <iframe title="Auto Appy API documentation" src={`/api/index.html${window.location.hash}`} style={{ width: '100%', height: '100dvh', border: 0, display: 'block' }} />;
  }
  return (
    <ErrorBoundary>
      <AuthProvider>
         <WorkspaceProvider>
        <Router>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          />
          <AppRoutes/>
        </Router>
        </WorkspaceProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
